import { GenericAdapter } from "./GenericAdapter";
import type { ColumnMapping, ParsedFile } from "./ImportAdapter";
import { isUpsellerStockDeductionRow, suggestUpsellerMapping } from "./upsellerRules.mjs";

export class UpsellerAdapter extends GenericAdapter {
  override readonly source = "upseller";
  override readonly automaticMapping = true;

  override async parse(file: File): Promise<ParsedFile> {
    const parsed = await super.parse(file);
    const rows = parsed.rows.filter(isUpsellerStockDeductionRow);
    const ignoredRows = parsed.rows.length - rows.length;
    return {
      ...parsed,
      rows,
      ignoredRows,
      warnings: ignoredRows
        ? [`${ignoredRows} linha(s) cancelada(s), em devolução ou sem pagamento foram excluídas da baixa.`]
        : [],
    };
  }

  override suggestMapping(headers: string[]): ColumnMapping {
    return suggestUpsellerMapping(headers);
  }
}
